import { Pipe, PipeTransform } from '@angular/core';
import { HandleInnerHtmlService } from 'src/app/shared/service/handle-inner-html.service';

@Pipe({ name: 'remarkLink' })
export class RemarkLinkPipe implements PipeTransform {
  constructor(private handleInnerHtmlService: HandleInnerHtmlService) {}

  transform(value: string): string {
    if (!value) return '';
    return this.handleInnerHtmlService.handleKycLink(this.handleInnerHtmlService.handleSpecialChar(value));
  }
}
